export const phoneNumberFormatter = (phoneNumber) => {
  if (/^\d{10}$/.test(phoneNumber)) {
    return `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(
      3,
      6
    )}-${phoneNumber.substring(6)}`;
  }
  if (/^\d{3}-\d{3}-\d{4}$/.test(phoneNumber)) {
    return `${phoneNumber.substring(0, 3)}${phoneNumber.substring(
      4,
      7
    )}${phoneNumber.substring(8)}`;
  }
  return '';
};
